/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Internalnamespace2Inputs */

const id_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace internal`)
};

const ms_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace dalaman`)
};

const da_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internt namespace`)
};

const de_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interner Namespace`)
};

const en_us2_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal namespace`)
};

const es_es2_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno`)
};

const es_mx2_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno`)
};

const fil_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal na namespace`)
};

const fr_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interne`)
};

const it_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno`)
};

const hu_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belső namespace`)
};

const nl_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne namespace`)
};

const no_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intern namespace`)
};

const pl_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wewnętrzny namespace`)
};

const pt_br2_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Namespace`)
};

const pt_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno`)
};

const ro_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace intern`)
};

const fi_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisäinen namespace`)
};

const sv_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internt namespace`)
};

const vi_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace nội bộ`)
};

const tr_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dahili ad alanı`)
};

const cs_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interní namespace`)
};

const bg_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вътрешно namespace`)
};

const ru_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутреннее пространство имён`)
};

const uk_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутрішній Namespace`)
};

const ar_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace داخلي`)
};

const hi_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आंतरिक नेमस्पेस`)
};

const th_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace ภายใน`)
};

const ja_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内部 Namespace`)
};

const zh_cn2_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Namespace`)
};

const zh_hant1_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Namespace`)
};

const ko_components_sandboxshell_internalnamespace2 = /** @type {(inputs: Components_Sandboxshell_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Namespace`)
};

/**
* | output |
* | --- |
* | "Internal namespace" |
*
* @param {Components_Sandboxshell_Internalnamespace2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_internalnamespace2 = /** @type {((inputs?: Components_Sandboxshell_Internalnamespace2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Internalnamespace2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "ms") return ms_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "da") return da_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "de") return de_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "fil") return fil_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "fr") return fr_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "it") return it_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "hu") return hu_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "nl") return nl_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "no") return no_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "pl") return pl_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "pt") return pt_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "ro") return ro_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "fi") return fi_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "sv") return sv_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "vi") return vi_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "tr") return tr_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "cs") return cs_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "bg") return bg_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "ru") return ru_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "uk") return uk_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "ar") return ar_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "hi") return hi_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "th") return th_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "ja") return ja_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_internalnamespace2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_internalnamespace2(inputs)
	return ko_components_sandboxshell_internalnamespace2(inputs)
});
export { components_sandboxshell_internalnamespace2 as "components.sandboxShell.internalNamespace" }